import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { role_list } from "../redux/api/dummyJson";
// import apiRequest from "../redux/api/apiRequest";
// import {
//   useLazyPermissionsListQuery,
//   useAddRoleMutation,
//   useLazyViewRoleQuery,
//   useUpdateRoleMutation,
// } from "../redux/api/api";
import { toast } from "react-toastify";
import { toggle_off, toggle_on } from "../../assets/img";
import Topbar from "../../components/Topbar/Topbar";
import { get, patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";

const AddRoles = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const navigate = useNavigate();
  const { state } = useLocation();
  const type = state?.type;
  const data = state?.data;
  console.log("data", type, data);
  const [role, setRole] = useState(data?.name ?? "");
  const [permissionList, setPermissionList] = useState(
    paginationData?.[path]?.permissionList ?? [],
  );
  const [selectedPermissions, setSelectedPermissions] = useState(
    data?.permissions ?? [],
  );
  useEffect(() => {
    if (!paginationData?.[path]) getModulesList();
  }, []);

  const getModulesList = async () => {
    // let moduleRes = await get(URLS.ROLE_PERMISSIONS_MODULE_LIST);
    let moduleGroupRes = await get(URLS.ROLE_GROUP_PERMISSIONS_MODULE_LIST);
    let permissionRes = await get(URLS.ROLE_PERMISSIONS_LIST);
    // if (
    //   moduleRes?.status === "success" &&
    //   permissionRes?.status === "success"
    // ) {
    let tempObj = {};
    permissionRes?.map((item) => {
      tempObj[item?.module] = [...(tempObj?.[item?.module] ?? []), item];
    });
    // let modules = moduleRes?.map((item) => ({
    //   ...item,
    //   permissions: tempObj?.[item?.id],
    // }));
    let groupedModules = moduleGroupRes?.data?.map((g) => {
      let modifiedModule = g?.modules?.map((module) => {
        let final = {
          ...module,
          permissions: tempObj?.[module?.id],
        };
        delete tempObj?.[module?.id];
        return final;
      });
      return { ...g, modules: modifiedModule };
    });
    console.log("permission group", groupedModules);
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        permissionList: groupedModules,
      },
    }));
    let totalLength =
      permissionRes?.length -
      Object.values(tempObj).reduce((sum, per) => sum + per?.length, 0);
    console.log("total length", totalLength);
    setPermissionList(groupedModules);
    // }
  };;
  const selectAll = () => {
    let totalPermissionCount = permissionList?.flatMap((module) =>
      module?.modules?.flatMap((item) => item?.permissions),
    ).length;
    if (selectedPermissions.length !== totalPermissionCount) {
      let permissions = [];
      permissionList?.forEach((module) => {
        module?.modules?.forEach((item) => {
          item?.permissions?.forEach((p) => {
            permissions.push(p?.id);
          });
        });
      });
      setSelectedPermissions(permissions);
    } else {
      setSelectedPermissions([]);
    }
  };

  const addEntireModule = (moduleId) => {
    let modulePermissions = [];
    let moduleSelected = true;
    let finded = permissionList
      .flatMap((module) => module?.modules)
      ?.find((item) => item?.id === moduleId);
    console.log("module select", moduleId, finded);
    finded?.permissions?.forEach((check) => {
      modulePermissions.push(check?.id);
      if (!selectedPermissions?.includes(check?.id)) moduleSelected = false;
    });
    setSelectedPermissions((prev) => {
      let filtered = prev.filter((f) => !modulePermissions.includes(f));
      return moduleSelected ? filtered : [...filtered, ...modulePermissions];
    });
  };

  console.log("selected permissions", selectedPermissions);
  const handlePermissionToggle = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id],
    );
  };

  const submit = async () => {
    if (!role || selectedPermissions?.length === 0) {
      toast.error(
        !role ? "Please Add Role Name" : "Atleast one Permission is Required ",
      );
      return;
    }
    let payload = {
      name: role,
      code: role?.replaceAll(" ", "_"),
    };
    payload[`permission${type === "edit" ? "s" : "_ids"}`] =
      selectedPermissions;
    let method = type === "edit" ? patch : post;
    let url = type === "edit" ? `${URLS.EDIT_ROLE}${data?.id}/` : URLS.ADD_ROLE;
    let res = await method(url, payload);
    if (res?.status) {
      toast.success(res?.message ?? "Roles Updated Successfully");
      navigate(-1);
    }
  };

  return (
    <div className=" home_section">
      <Topbar header={type == "view" ? "Role View" : "Role Edit"} />
      <div className="">
        <div className="d-flex ac-jb">
          <div className="">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  mb-1">
              Role Name
            </h4>
            <input
              value={role}
              onChange={(e) => setRole(e.target.value)}
              type="text"
              className="role-input  ps-2 w-100"
              placeholder="Role Name"
              disabled={type == "view"}
            />
            {/* {error && !name && <p className="err">Enter Role Name</p>} */}
          </div>
          {/* {type != "view" && ( */}
          <div className="">
            <button
              onClick={() => {
                selectAll();
              }}
              className=" f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-16 fs-xxl-18  add-btn white"
            >
              Select All
            </button>
          </div>
          {/* )} */}
        </div>
        <div className="roles-bg">
          <h4 className="f4 fs-sm-10 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 mt-3 primary">
            Permissions{" "}
            <span className="err f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14">
              (Atleast one permission is Required)*
            </span>
          </h4>
          {permissionList?.map((module) => {
            return (
              <div className="mt-5">
                <p className="f4 fs-xs-12 trans fs-sm-14 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
                  {module?.group_name}
                </p>
                <hr
                  className="primary mt-1 mb-1 "
                  style={{
                    borderWidth: "2px",
                    opacity: 1,
                  }}
                />

                <div className="d-flex flex-wrap mt-2 ps-3 gap-2">
                  {module?.modules?.map((item, id) => {
                    let moduleSelected = true;
                    item?.permissions?.forEach((check) => {
                      if (!selectedPermissions?.includes(check?.id))
                        moduleSelected = false;
                    });
                    return (
                      <div className="w-24 mt-3 role-box">
                        <div className="d-flex ac-js gap-2 mb-3">
                          <p className="f3 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
                            {item?.name}
                          </p>
                          {type != "view" && (
                            <img
                              src={moduleSelected ? toggle_on : toggle_off}
                              className="roles-icon pointer"
                              alt=""
                              onClick={() => {
                                addEntireModule(item?.id);
                              }}
                            />
                          )}
                        </div>
                        <div className="d-flex ac-js">
                          <div>
                            {item?.permissions?.map((permission, index) => {
                              const isSelected = selectedPermissions?.includes(
                                permission.id,
                              );
                              return (
                                <div className="d-flex ac-js gap-2 mb-2">
                                  <img
                                    src={isSelected ? toggle_on : toggle_off}
                                    className="roles-icon pointer"
                                    alt=""
                                    onClick={() => {
                                      if (type != "view") {
                                        handlePermissionToggle(
                                          permission.id,
                                          item?.id,
                                        );
                                      }
                                    }}
                                  />
                                  <p className=" f1 fs-xs-10 trans fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 mb-0 ">
                                    {permission?.name}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
          <div className="d-flex ac-je">
            {type != "view" && selectedPermissions?.length > 0 && (
              <button
                onClick={submit}
                className="add-btn white f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
              >
                {/* <div
                    class="spinner-border spinner-border-sm "
                    role="status"
                    style={{ marginRight: "5px" }}
                  /> */}
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRoles;
